import { useMemo } from 'react';
import { PlansBillingController } from '../../../controllers';
import constant from '../../../utils/constant';
import { amountFormatter } from '../../../utils/utils';
import moment from 'moment';
import { MimaOptionMenu } from '../../../components';

export const usePlanSubscriptions = ({ handleOptionSelect }) => {
	const {
		isLoading: loadingSubs,
		isFetching: fetchingSubs,
		currentPage: currentSubPage,
		setCurrentPage: setCurrentSubPage,
		setSearchQuery: setSubSearchQuery,
		limit: subLimit,
		setLimit,
		data,
	} = PlansBillingController.useGetSubs();

	const onSubLimitChange = limit => {
		setLimit(limit);
		setCurrentSubPage(0);
	};

	const subTableData = useMemo(() => {
		if (data?.status === constant.Success) {
			return data?.data?.value || [];
		}
		return [];
	}, [data]);

	const subscriptionTotalCounts = useMemo(() => {
		if (data?.status === constant.Success) {
			return data?.data?.totalCounts;
		}
		return 0;
	}, [data]);

	const subTableColumns = [
		{
			Header: 'Plan Name',
			accessor: 'customer',
			Cell: ({ cell }) => {
				const row = cell.row.original;
				const customerName = row.customer.fullname;
				const customerEmail = row.customer.email;

				return (
					<span style={{ display: 'flex', flexDirection: 'column' }}>
						<span style={{ fontWeight: '600' }}>{customerName}</span>
						<span>{customerEmail}</span>
					</span>
				);
			},
		},
		{
			Header: 'Plan',
			accessor: 'plan',
			Cell: ({ cell }) => {
				const row = cell.row.original;
				const planName = row.plan.name;

				return <span>{planName}</span>;
			},
		},
		{
			Header: 'Amount',
			Cell: ({ cell }) => {
				const row = cell.row.original;
				const planAmount = row.plan.amount;
				const currencyCode = row.plan.currencyCode;

				return <span>{amountFormatter(currencyCode).format(planAmount)}</span>;
			},
		},
		{
			Header: 'Cycle',
			accessor: 'cycle',
			Cell: ({ cell }) => {
				const row = cell.row.original;
				const planCycle = row.plan.cycle;
				const interval = row.plan.interval;

				const getCycleLabel = interval => {
					switch (interval) {
						case 'daily':
							return 'days';
						case 'weekly':
							return 'weeks';
						case 'monthly':
							return 'months';
						case 'quarterly':
							return 'quarters';
						case 'yearly':
							return 'years';
						default:
							return 'months';
					}
				};

				return (
					<span>
						{planCycle} {getCycleLabel(interval)}
					</span>
				);
			},
		},
		{
			Header: 'Start Date',
			accessor: 'startDate',
			Cell: ({ cell }) => {
				const startDate = cell.row.original.startDate;

				return <span>{moment(startDate).format('DD-MM-YYYY')}</span>;
			},
		},
		{
			Header: 'Status',
			accessor: 'status',
		},
		{
			Header: 'Actions',
			Cell: ({ cell }) => {
				const row = cell.row.original;
				return (
					<MimaOptionMenu
						options={[
							{
								value: 'viewSub',
								label: 'View Subscription Payments',
							},
							// {
							// 	value: 'edit',
							// 	label: 'Edit Plan',
							// },
						]}
						onOptionSelected={option => {
							handleOptionSelect(row, option);
						}}
					/>
				);
			},
		},
	];

	return {
		loadingSubs,
		fetchingSubs,
		currentSubPage,
		setCurrentSubPage,
		setSubSearchQuery,
		subLimit,
		onSubLimitChange,
		subTableData,
		subscriptionTotalCounts,
		subTableColumns,
	};
};
